import React from 'react';
import { Cta1, SubpageBanner } from '../components';
import { useTranslation } from 'react-i18next';

const Management = () => {
    const { t } = useTranslation();

    return (
        <div className="subpage-content">
            {/* Page Banner */}
            <SubpageBanner 
                title={t('management.bannerTitle')}
                path="/about-us"
            />

            <div className="about-us-page">
                {/* Yönetim Kadrosu */}
                <div className="about-management-section">
                    <div className="container">
                        <h2 className="about-section-title">{t('aboutUs.management.title')}</h2>
                        <p className="about-section-desc">{t('aboutUs.management.desc')}</p>
                        <div className="row g-4 mt-4">
                            {t('aboutUs.management.team', { returnObjects: true }).map((member, index) => (
                                <div key={index} className="col-lg-6">
                                    <div className="about-member-card">
                                        <h4 className="about-member-name">{member.name}</h4>
                                        <p className="about-member-title">{member.title}</p>
                                        <p className="about-member-desc">{member.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <Cta1
                    title={<><span style={{color: '#31cce5' }}>{t('home.ctaInvestment')}</span> {t('home.ctaTitle')}</>}
                subtitle={<span>{t('home.ctaSubtitle')}</span>}
                />
            </div>
        </div>
    );
};

export default Management;
